// extracted by mini-css-extract-plugin
module.exports = {"input":"_93444fe79c--input--CkYDu","tag":"_93444fe79c--tag--38pEj"};